var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.22,
    height: 18.533,
    viewBox: "0 0 20.22 18.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_002---API",
    "data-name": "002---API"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M17.017,11.794H4.381a4.381,4.381,0,0,1,0-8.761h.085a5.054,5.054,0,0,1,9.265,0A3.881,3.881,0,0,1,17.216,5.4a3.2,3.2,0,0,1-.2,6.4ZM4.381,3.707a3.707,3.707,0,0,0,0,7.413H17.017a2.527,2.527,0,0,0,0-5.055h-.034a.337.337,0,0,1-.318-.225,3.2,3.2,0,0,0-3.038-2.134c-.033,0-.066,0-.1,0a.34.34,0,0,1-.338-.216A4.38,4.38,0,0,0,5,3.5a.336.336,0,0,1-.349.216,2.713,2.713,0,0,0-.273-.012Z",
    transform: "translate(0 0)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M4.933,18.565a.336.336,0,0,1-.262-.125A3.024,3.024,0,0,1,5.74,13.8a.337.337,0,1,1,.288.609,2.369,2.369,0,0,0-1.354,2.132A2.316,2.316,0,0,0,5.2,18.016a.337.337,0,0,1-.262.549Z",
    transform: "translate(-2.652 -9.13)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M16.337,19.717a.337.337,0,0,1-.32-.444l1.348-4.044a.337.337,0,0,1,.639.213l-1.348,4.044A.337.337,0,0,1,16.337,19.717Z",
    transform: "translate(-10.609 -9.945)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M21.685,19.717a.337.337,0,0,1-.32-.231l-1.348-4.044a.337.337,0,0,1,.639-.213L22,19.274a.337.337,0,0,1-.32.444Z",
    transform: "translate(-13.26 -9.945)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M19.577,22.674h-1.57a.337.337,0,0,1,0-.674h1.57a.337.337,0,0,1,0,.674Z",
    transform: "translate(-11.716 -14.587)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M27.337,19.718A.337.337,0,0,1,27,19.381V15.337a.337.337,0,1,1,.674,0v4.044A.337.337,0,0,1,27.337,19.718Z",
    transform: "translate(-17.902 -9.945)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M28.685,17.7H27.337A.337.337,0,0,1,27,17.359V15.337A.337.337,0,0,1,27.337,15h1.348a1.348,1.348,0,1,1,0,2.7Zm-1.011-.674h1.011a.674.674,0,1,0,0-1.348H27.674Z",
    transform: "translate(-17.902 -9.945)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M39.337,19.718A.337.337,0,0,1,39,19.381V15.337a.337.337,0,1,1,.674,0v4.044A.337.337,0,0,1,39.337,19.718Z",
    transform: "translate(-25.858 -9.945)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M38.359,15.674H36.337a.337.337,0,1,1,0-.674h2.022a.337.337,0,1,1,0,.674Z",
    transform: "translate(-23.869 -9.945)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M38.359,27.674H36.337a.337.337,0,1,1,0-.674h2.022a.337.337,0,1,1,0,.674Z",
    transform: "translate(-23.869 -17.902)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M11.339,40.148a.621.621,0,0,1-.247-.051l-2.108-.874a.628.628,0,0,1-.342-.344A.61.61,0,0,1,8.65,38.4l.5-1.214a6.868,6.868,0,0,1-1.311-1.311l-1.225.506a.616.616,0,0,1-.477,0,.623.623,0,0,1-.337-.335L4.93,33.928a.62.62,0,0,1,.327-.811l1.194-.492a.337.337,0,0,1,.257.623l-1.136.468.835,2.024,1.422-.587a.337.337,0,0,1,.4.118,6.2,6.2,0,0,0,1.525,1.525.337.337,0,0,1,.118.4l-.587,1.419,2.022.838.588-1.42a.337.337,0,0,1,.37-.2,6.089,6.089,0,0,0,2.152,0,.338.338,0,0,1,.371.2l.591,1.423,2.019-.837L16.815,37.2a.337.337,0,0,1,.119-.405,6.136,6.136,0,0,0,1.524-1.521.336.336,0,0,1,.4-.117l1.422.588.839-2.023-.811-.338a.337.337,0,0,1,.116-.652.353.353,0,0,1,.133.026l.866.361a.616.616,0,0,1,.338.34.626.626,0,0,1,0,.476l-.877,2.114a.622.622,0,0,1-.822.335l-1.216-.5a6.8,6.8,0,0,1-1.31,1.309l.505,1.224a.6.6,0,0,1,0,.47.628.628,0,0,1-.343.344l-2.111.875a.621.621,0,0,1-.815-.339l-.507-1.222a6.772,6.772,0,0,1-1.852,0l-.505,1.221a.623.623,0,0,1-.575.387Zm-.048-.644h0Zm.063-.028h0Zm6.069-.805v0ZM9.27,38.665h0Zm8.179-.065h0Zm-8.208,0h0Zm11.024-2.812h0ZM6.358,35.759h0Zm13.97,0h0Zm.842-2.022h0ZM5.552,33.669h0Z",
    transform: "translate(-3.236 -21.614)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M20.669,36.7a5.08,5.08,0,0,1-4.719-3.249.337.337,0,1,1,.63-.241,4.377,4.377,0,0,0,8.179,0,.337.337,0,1,1,.63.241A5.08,5.08,0,0,1,20.669,36.7Z",
    transform: "translate(-10.56 -21.875)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M18.337,6.7a.337.337,0,0,1-.32-.444A2.973,2.973,0,0,1,20.7,4a.337.337,0,0,1,0,.674,2.326,2.326,0,0,0-2.041,1.791A.337.337,0,0,1,18.337,6.7Z",
    transform: "translate(-11.935 -2.652)",
    fill: "#86FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.1cc0eb8b817684597b67308f2a5a2ead.svg";
export { ForwardRef as ReactComponent };